import { inject, Injectable } from '@angular/core';
import { PrintOfficeDto } from '../models/server-models/entities/print-office-dto';
import { HttpClient } from '@angular/common/http';
import { GetPrintOfficesResponseDto } from '../models/server-models/reseponse-dtos/get-print-offices-response-dto';
import { environment } from '../environments/environment';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, tap } from 'rxjs';
import {
  GetOfficesOffersResponseDto,
  OfferPricingSummary,
} from '../models/server-models/reseponse-dtos/get-offices-offers-response.dto';
import { GetOfficesOffersRequestDto } from '../models/server-models/request-dtos/get-offices-offers-request-dto';
import { ErrorService } from '../../../shared/services/error.service';
import { ChangePrintOfficeAvailabilityRequestDto } from '../models/server-models/request-dtos/change-office-availability-request-dto';
import { GetPrintOfficeResponseDto } from '../models/server-models/reseponse-dtos/get-print-office-response-dto';
import { GetPrintOfficeRequestDto } from '../models/server-models/request-dtos/get-print-office-request-dto';

@Injectable({ providedIn: 'root' })
export class PrintOfficeService {
  private httpClient = inject(HttpClient);
  private errorService = inject(ErrorService);

  private printOfficesSubject = new BehaviorSubject<PrintOfficeDto[] | null>(null);
  private printOffices$ = this.printOfficesSubject.asObservable();

  getPrintOffices(): Observable<PrintOfficeDto[] | null> {
    if (!this.printOfficesSubject.value) {
      return this.httpClient.get<GetPrintOfficesResponseDto>(environment.apiUrl + '/api/print-offices').pipe(
        map((r) => r.printOffices),
        tap((data) => this.printOfficesSubject.next(data)), // Cache result
        catchError((err) => {
          this.errorService.handleError(err);
          return of(null);
        }),
        shareReplay(1) // Ensures the latest value is shared across multiple subscribers
      );
    }
    return this.printOffices$; // Return cached data if available
  }

  getOfficeOffers(requestDto: GetOfficesOffersRequestDto): Observable<Record<string, OfferPricingSummary>> {
    return this.httpClient
      .post<GetOfficesOffersResponseDto>(environment.apiUrl + '/api/print-offices/offers', requestDto)
      .pipe(map((r) => r.officeOffers));
  }

  changeAvailability(dto: ChangePrintOfficeAvailabilityRequestDto):
      Observable<any>{
        return this.httpClient
               .put<any>(environment.apiUrl + '/api/print-offices/availability', dto);;
  }

  getPrintOffice(): Observable<GetPrintOfficeResponseDto> {
      return this.httpClient
             .get<GetPrintOfficeResponseDto>(environment.apiUrl + '/api/print-offices/office');
  }
}
